import React from "react";
import "./Profile.css";

function Profile() {
  return (
    <div className="profile">
      <h3>Profile</h3>
      <div class="col-md-6 border-right">
        <div class="p-2 py-3">
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="labels">Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="first name"
                // value=""
              />
            </div>
            <div class="col-md-6">
              <label class="labels">Surname</label>
              <input
                type="text"
                class="form-control"
                // value=""
                placeholder="surname"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <label class="labels">Mobile Number</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter phone number"
                // value=""
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Address Line 1</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter address line 1"
                // value=""
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Address Line 2</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter address line 2"
                // value=""
              />
            </div>
            <div class="col-md-12">
              <label class="labels">State</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter address line 2"
                // value=""
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Area</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter address line 2"
                // value=""
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Email ID</label>
              <input
                type="text"
                class="form-control"
                placeholder="enter email id"
                // value=""
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <label class="labels">Country</label>
              <input
                type="text"
                class="form-control"
                placeholder="country"
                // value=""
              />
            </div>
            <div class="col-md-6">
              <label class="labels">State/Region</label>
              <input
                type="text"
                class="form-control"
                // value=""
                placeholder="state"
              />
            </div>
          </div>
          <div class="mt-5 text-center">
            <button class="btn btn-primary profile-button" type="button">
              Save Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
